export default "__VITE_ASSET__7Z2lPWk0__";